var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlurInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_3320_19674)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3320_19674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4998 27.001H36.5003C31.5508 27.001 27.5005 31.0513 27.5005 36.0008V54.0012C27.5005 58.9493 31.5508 63.001 36.5003 63.001H54.4998C59.4492 63.001 63.4996 58.9493 63.4996 54.0012V36.0008C63.4996 31.0513 59.4492 27.001 54.4998 27.001ZM60.4995 54.0012C60.4995 57.3086 57.8091 60.0009 54.4998 60.0009H36.5003C33.1924 60.0009 30.5006 57.3086 30.5006 54.0012V36.0008C30.5006 32.6925 33.1924 30.001 36.5003 30.001H54.4998C57.8091 30.001 60.4995 32.6925 60.4995 36.0008V54.0012Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2514 37.4999C56.494 37.4999 57.5014 36.4926 57.5014 35.2499C57.5014 34.0073 56.494 33 55.2514 33C54.0088 33 53.0015 34.0073 53.0015 35.2499C53.0015 36.4926 54.0088 37.4999 55.2514 37.4999Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4998 36C40.5283 36 36.5 40.0287 36.5 44.9998C36.5 49.969 40.5283 54.0004 45.4998 54.0004C50.4699 54.0004 54.4995 49.969 54.4995 44.9998C54.4995 40.0287 50.4699 36 45.4998 36ZM45.4998 51.0004C42.1865 51.0004 39.5001 48.314 39.5001 44.9998C39.5001 41.6856 42.1865 39.0001 45.4998 39.0001C48.8131 39.0001 51.4995 41.6856 51.4995 44.9998C51.4995 48.314 48.8131 51.0004 45.4998 51.0004Z",
    fill: "#A9A9A9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 2.8125C68.7622 2.8125 87.6875 21.7378 87.6875 45C87.6875 68.2622 68.7622 87.1875 45.5 87.1875C22.2378 87.1875 3.3125 68.2622 3.3125 45C3.3125 21.7378 22.2378 2.8125 45.5 2.8125ZM45.5 0C20.6487 0 0.5 20.1487 0.5 45C0.5 69.8512 20.6487 90 45.5 90C70.3512 90 90.5 69.8541 90.5 45C90.5 20.1459 70.3512 0 45.5 0Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3320_19674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3320_19674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(27.5 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurInsta);
export default __webpack_public_path__ + "static/media/BlurInsta.5db30c7d700e44e9102a759947b87b92.svg";
export { ForwardRef as ReactComponent };